var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 146,
    viewBox: "0 0 152 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 146,
    rx: 15,
    fill: "#05FF76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.093 51.6216L22.1763 30.8918C22.2066 23.4198 29.7994 18.7562 35.8978 22.464L52.82 32.7524L83.2415 51.6216L52.82 70.4909L35.8978 80.7793C29.7994 84.4871 22.2066 79.8261 22.1763 72.3542L22.093 51.6216Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.546 51.6216L130.473 69.7874C130.437 78.4031 121.681 83.7809 114.646 79.5066L99.8188 70.4908L69.3973 51.6216L99.8188 32.7524L114.646 23.7366C121.678 19.4596 130.437 24.8374 130.473 33.4558L130.546 51.6216Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3194 94.9903C80.7442 94.9903 84.3312 91.175 84.3312 86.4685C84.3312 81.7621 80.7442 77.9468 76.3194 77.9468C71.8947 77.9468 68.3077 81.7621 68.3077 86.4685C68.3077 91.175 71.8947 94.9903 76.3194 94.9903Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3194 125.065C80.7442 125.065 84.3312 121.25 84.3312 116.544C84.3312 111.837 80.7442 108.022 76.3194 108.022C71.8947 108.022 68.3077 111.837 68.3077 116.544C68.3077 121.25 71.8947 125.065 76.3194 125.065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoButton);
export default __webpack_public_path__ + "static/media/logo-button.d5e7caacf91963d14139d397aa1bd445.svg";
export { ForwardRef as ReactComponent };